import { StyleSheet, Platform, Dimensions } from 'react-native'
import { JDDevice } from '@jdreact/jdreact-core-lib'
import { NAVIGATION_BAR_HEIGHT, SYS_BAR_HEIGHT } from '../../utils/steep';
const { height } = Dimensions.get('window');
const styles = StyleSheet.create({
	page: {
		position: 'relative',
		backgroundColor: '#f6f6f6',
		flex: 1,
	},
	navShareView: {
		position: 'absolute',
		top: 0,
		right: 0
	},
	shareIconBox: {
		width: JDDevice.getRpx(88),
		height: JDDevice.getRpx(88)
	},
	shareIcon: {
		width: JDDevice.getRpx(44),
		height: JDDevice.getRpx(44),
		marginTop: JDDevice.getRpx(22),
		marginLeft: JDDevice.getRpx(22),
	},
	lockScroll: {
		overflow: 'hidden'
	},
	brokerInfoBox: {
		backgroundColor: 'rgba(0,0,0,.6)',
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		// zIndex: 9999,
	},
	brokerInfoImgClose: {
		width: '100%',
		paddingTop: JDDevice.getRpx(30),
		height: JDDevice.getRpx(80),
		flexDirection: 'row',
		justifyContent: 'center',
	},
	imgCloseIcon: {
		width: JDDevice.getRpx(74),
		height: JDDevice.getRpx(74),
	},
	brokerInfoCon: {
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		...Platform.select({
			web: {
				height: height
			}
		})
	},
	brokerInfoImg: {
		width: JDDevice.getRpx(640),
		height: JDDevice.getRpx(850),
		resizeMode: 'contain'
	},
	container: {
		width: '100%',
	},
	containRow: {
		width: '100%',
		flexDirection: 'row',
		justifyContent: 'space-between'
	},
	// 楼盘信息模块
	desInfoWrap: {
		backgroundColor: '#FFF',
		paddingVertical: JDDevice.getRpx(36),
		paddingHorizontal: JDDevice.getRpx(30),
		marginBottom: JDDevice.getRpx(24),
		marginTop: JDDevice.getRpx(-84),
		borderRadius: JDDevice.getRpx(24),
		zIndex: 10
	},
	secondAdvWrap: {
		backgroundColor: '#FFF',
		width: '100%',
		marginBottom: JDDevice.getRpx(24),
	},
	desInfoPriceWrap: {
		alignItems: "baseline",
		justifyContent: 'flex-start',
		marginTop: JDDevice.getRpx(4),
	},

	desInfoPrice: {
		marginRight: JDDevice.getRpx(7),
		color: '#FA2C19',
		fontWeight: 'bold',
		fontSize: JDDevice.getRpx(42)
	},
	desInfoSqur: {
		color: '#848689',
		fontSize: JDDevice.getRpx(28),
		...Platform.select({
			android: {
				lineHeight: JDDevice.getRpx(48)
			}
		})
	},
	desInfoTitle: {
		color: '#1a1a1a',
		fontSize: JDDevice.getRpx(38),
		fontWeight: 'bold',
		lineHeight: JDDevice.getRpx(53),
	},
	desInfoLabelWrap: {
		marginTop: JDDevice.getRpx(30),
	},
	desInfoLabel: {
		color: '#999999',
		fontSize: JDDevice.getRpx(22),
		paddingHorizontal: JDDevice.getRpx(10),
		paddingVertical: JDDevice.getRpx(7),
		borderRadius: JDDevice.getRpx(4),
		backgroundColor: '#F6F6F6',
		marginRight: JDDevice.getRpx(12),
	},
	desInfoLabelLight: {
		paddingHorizontal: JDDevice.getRpx(10),
		paddingVertical: JDDevice.getRpx(7),
		borderRadius: JDDevice.getRpx(4),
		marginRight: JDDevice.getRpx(12),
	},

	desInfoPublishWrap: {
		marginTop: JDDevice.getRpx(15),
	},
	desInfoPublish: {
		fontSize: JDDevice.getRpx(28),
		lineHeight: JDDevice.getRpx(40),
		color: '#848689'
	},
	desInfoDes: {
		backgroundColor: '#E3E5E9',
		width: '100%',
		height: JDDevice.getDpx(1),
		marginTop: JDDevice.getRpx(28),
		marginBottom: JDDevice.getRpx(28),
	},
	// 总价，建筑面积，户型
	desInfoMainWrap: {
		flexWrap: 'wrap',
		marginBottom: JDDevice.getRpx(48),
		marginTop: JDDevice.getRpx(30),
		justifyContent: 'flex-start'
	},
	desInfoMainWrapCota1: {
		width: JDDevice.getRpx(234),
	},
	desInfoMainWrapCota2: {
		width: JDDevice.getRpx(234),
	},
	// 总价
	squareWrapper: {
		flexDirection: 'row'
	},
	// 总价平方
	square: {
		top: JDDevice.getRpx(0),
		fontSize: JDDevice.getRpx(22),
		position: 'relative',
		color: '#FA2C19'
	},
	// 单价平方
	squareUnit: {
		top: JDDevice.getRpx(0),
		fontSize: JDDevice.getRpx(22),
		position: 'relative',
	},
	desInfoDetailMainValue: {
		fontSize: JDDevice.getRpx(38),
		fontFamily: 'JDZhengHT-Regular',
		fontWeight: 'normal',
		color: '#FA2C19',
		height:JDDevice.getRpx(53),
		lineHeight:JDDevice.getRpx(53)
	},
	wan:{
		fontWeight: 'bold'
	},
	desInfoDetailMainKey: {
		fontSize: JDDevice.getRpx(24),
		fontFamily: 'PingFang SC',
		fontWeight: 'normal',
		color: '#999999',
		marginTop: JDDevice.getRpx(10)
	},
	desInfoDetailWrap: {
		flexWrap: 'wrap',
		justifyContent: "space-between"
	},
	desInfoDetailCota: {
		width: '50%',
		marginVertical: JDDevice.getRpx(8),
		justifyContent: "center"
	},
	desInfoEven: {
		width: JDDevice.getRpx(262)
	},
	desInfoDetailKey: {
		marginRight: JDDevice.getRpx(20),
		fontSize: JDDevice.getRpx(28),
		fontFamily: "PingFang SC",
		fontWeight: 'normal',
		color: '#999999'
	},
	desInfoDetailValue: {
		flex: 1,
		fontSize: JDDevice.getRpx(28),
		fontFamily: "PingFang SC",
		fontWeight: '500',
		color: '#1A1A1A'
	},
	// 单价
	desInfoDetailPrice:{
		fontSize: JDDevice.getRpx(28),
		fontFamily: "PingFang SC",
		fontWeight: '500',
		color: '#1A1A1A'
	},
	desInfoDetailFlexOne: {
		width: '100%'
	},
	desInfoDetailTextFlexOne: {
		flex: 1,
	},
	// 地址图标
	houseAddress: {
		width: JDDevice.getRpx(40),
		height: JDDevice.getRpx(40),
	},

	desInfoDetailSqurDetailWrap: {
		flexDirection: 'row',
		flex: 1,
		width: '100%',
		marginVertical: JDDevice.getRpx(10),
	},
	desInfoDetailJumpBtn: {
		width: JDDevice.getRpx(200),
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
	desInfoDetailJumpBtnText: {
		fontSize: JDDevice.getRpx(24),
		color: '#555555',
		fontFamily: "PingFang SC",
		fontWeight: 'normal'
	},
	desInfoDetailJumpBtnIcon: {
		width: JDDevice.getRpx(26),
		height: JDDevice.getRpx(26),
		marginBottom: JDDevice.getRpx(3),
	},

	rowLine: {
		width: JDDevice.getRpx(654),
		marginLeft: 'auto',
		marginRight: 'auto',
		height: JDDevice.getDpx(1),
		backgroundColor: 'rgba(0,0,0,0.08)',
		marginBottom: JDDevice.getRpx(1)
	}, // 横线的样式

	boxMargin: {
		marginHorizontal: JDDevice.getRpx(30)
	},
	// 房源情况
	moduleBox: {
		marginBottom: JDDevice.getRpx(24),
		borderRadius: JDDevice.getRpx(24),
		backgroundColor: "#fff",
		overflow: 'hidden'
	},
	// 房源背景图
	houseBg: {
		position: 'absolute',
		left: 0,
		top: 0,
		width: '100%',
		height: JDDevice.getRpx(258)
	},
	// 联系经纪人模块
	brokerContainer: {
		backgroundColor: "#fff",
		marginBottom: JDDevice.getRpx(24),
		borderRadius: JDDevice.getRpx(24)
	},
	// 小区及位置周边
	aroundBox: {
		backgroundColor: "#fff",
		marginBottom: JDDevice.getRpx(24),
		borderRadius: JDDevice.getRpx(24)
	},
	dataSource: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		height: JDDevice.getRpx(143),
		backgroundColor: "#fff"
	},
	houseIcon: {
		width: JDDevice.getRpx(58),
		height: JDDevice.getRpx(68),
		marginRight: JDDevice.getRpx(24)
	},
	sourceText: {
		height: JDDevice.getRpx(34),
		lineHeight: JDDevice.getRpx(34),
		fontSize: JDDevice.getRpx(24)
	},
	updateTime: {
		height: JDDevice.getRpx(30),
		lineHeight: JDDevice.getRpx(30),
		fontSize: JDDevice.getRpx(22),
		color: '#aaa'
	},
	// 推荐房源
	houseSourceContainer: {
		backgroundColor: "#fff",
		paddingBottom: JDDevice.getRpx(12),
		marginBottom: JDDevice.getRpx(24),
		borderRadius: JDDevice.getRpx(24)
	},
	toastStyle: {
		backgroundColor: "rgba(0,0,0,0.6)"
	},
	image: {
		width: JDDevice.width,
		height: JDDevice.getRpx(420),
		resizeMode: 'stretch'
	},
	brokerFooter: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 2,
		height: JDDevice.getRpx(150),
		// width: JDDevice.getRpx(750),
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		backgroundColor: '#fff',
		borderTopLeftRadius: JDDevice.getRpx(48),
		borderTopRightRadius: JDDevice.getRpx(48),
		paddingHorizontal: JDDevice.getRpx(36),
		paddingTop: JDDevice.getRpx(30),
		...Platform.select({ // 不同的平台执行不同的阴影样式
			ios: {
				shadowColor: '#000',
				shadowOffset: { h: 0, w: JDDevice.getRpx(10) }, // ios设置阴影
				shadowOpacity: 0.05
			},
			web: {
				boxShadow: '0 -3px 10px rgba(0,0,0,0.05)'
			}
		}),
	},
	brokerFooterLeft: {
		position: 'relative',
		flexDirection: 'row',
		alignItems: 'center',
		width: JDDevice.getRpx(339),
		paddingLeft: JDDevice.getRpx(34),
		paddingRight: JDDevice.getRpx(10),
		zIndex: 1,
	},
	brokerPic: {
		width: JDDevice.getRpx(80),
		height: JDDevice.getRpx(80),
		borderRadius: JDDevice.getRpx(40),
		borderWidth: JDDevice.getDpx(2),
		borderStyle: 'solid',
		borderColor: '#FA2C19',
		marginRight: JDDevice.getRpx(26)
	},
	brokerName: {
		fontSize: JDDevice.getRpx(32),
		fontWeight: 'bold',
		color: '#424854',
		marginBottom: JDDevice.getRpx(10)
	},
	brokerCompany: {
		fontSize: JDDevice.getRpx(24),
		color: '#848689'
	},
	brokerFooterRight: {
		position: 'relative',
		flex: 1,
		height: '100%',
		backgroundColor: '#FA2C19',
		zIndex: 1,
		width: JDDevice.getRpx(411)
	},
	brokerFooterRightInfo: {
		fontSize: JDDevice.getRpx(34),
		color: '#fff',
		fontWeight: '400'
	},
	footerBg: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		width: JDDevice.getRpx(750),
		height: JDDevice.getRpx(118)
	},
	iphoneXDiv: {
		width: JDDevice.getRpx(750),
		height: 17,
		backgroundColor: '#F0F2F5'
	},
	paddingDiv: {
		marginHorizontal: JDDevice.getRpx(24),
	},
	skeletonpageBox:{
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%',
		overflow:'hidden'
	},
	skeletonImg:{
		width: '100%',
		height:'100%',
	},
	errpageBox: {
		position: 'absolute',
		top: NAVIGATION_BAR_HEIGHT + SYS_BAR_HEIGHT,
		right: 0,
		bottom: 0,
		left: 0,
		zIndex: 20000,
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'rgba(246,246,246,1)',
		width: '100%'
	},
	errpageImg: {
		width: JDDevice.getRpx(378),
		height: JDDevice.getRpx(392),
	},
	errpageText: {
		fontSize: JDDevice.getRpx(32),
		color: '#808080',
		paddingVertical: JDDevice.getRpx(6),
	},
	errpageTip: {
		fontSize: JDDevice.getRpx(26),
		color: '#808080',
	},
	errpageBtn: {
		width: JDDevice.getRpx(200),
		height: JDDevice.getRpx(88),
		borderRadius: JDDevice.getRpx(44),
		borderColor: '#FA2C19',
		borderWidth: JDDevice.getDpx(1),
		marginTop: JDDevice.getRpx(44),
		justifyContent: 'center'
	},
	errpageBtnText: {
		fontSize: JDDevice.getRpx(34),
		color: '#FA2C19',
		textAlign: 'center'
	},
	houseChangeBox: {
		flexDirection: 'row',
		alignItems: 'center',
		paddingBottom: JDDevice.getRpx(36),
		paddingLeft: JDDevice.getRpx(30),
	},
	houseChangeIcon: {
		width: JDDevice.getRpx(24),
		height: JDDevice.getRpx(24),
	},
	houseChangeText: {
		fontSize: JDDevice.getRpx(28),
		color: '#1A1A1A',
		paddingLeft: JDDevice.getRpx(20),
	},
	houseChangeLine: {
		position: 'absolute',
		top: JDDevice.getRpx(-32),
		left: JDDevice.getRpx(40),
		width: JDDevice.getRpx(3),
		height: JDDevice.getRpx(30),
		backgroundColor: '#1A1A1A'
	},
	navMiddBox: {
		width: '100%',
		height: JDDevice.getRpx(88),
		justifyContent: 'center',
		alignItems: 'center'
	},
	navMiddText: {
		fontSize: JDDevice.getRpx(32),
		color: '#2E2D2D',
	},
	liuziView: {
		width: JDDevice.getRpx(150),
		height: JDDevice.getRpx(150),
		position: 'absolute',
		bottom: JDDevice.getRpx(200),
		right: JDDevice.getRpx(18),
	},
	liuziBox: {

	},
	liuziIcon: {
		width: JDDevice.getRpx(150),
		height: JDDevice.getRpx(150),
	},
	liuziBigWindow: {
		position: 'absolute',
		bottom: 0,
		right: 0,
		width: JDDevice.getRpx(750),
		height: '100%',
	},
});


export default styles
